import { extendTheme, theme } from '@chakra-ui/react';
import { colors } from './colors';

export const chakraTheme = extendTheme({
  styles: {
    global: () => ({
      body: {
        backgroundColor: 'bgColor.100',
        color: 'textColor.100',
        lineHeight: '21px',
        fontFamily: `Poppins, ${theme.fonts.body}`,
        minH: '100vh',
        minW: 'max-content',
      },
      '#root': {
        minH: '100vh',
        display: 'flex',
        flexDirection: 'column',
      },
    }),
  },
  config: {
    initialColorMode: 'dark',
    useSystemColorMode: false,
  },
  colors,
});
